// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"676":"f2ffbbc3","707":"acd0d8f4","827":"95ed90a3"}[chunkId] + ".chunk.js";
};